module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.f7cf8505.png";